import Icon from "@ant-design/icons";

const CoveredCarParkSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    stroke="#31493C"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
    <path d="M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
    <path d="M3 6l9 -4l9 4" />
  </svg>
);

const CoveredCarParkIcon = (props) => (
  <Icon component={CoveredCarParkSvg} {...props} />
);

export default CoveredCarParkIcon;
